import { RouteObject } from "react-router-dom";
import { CompanyList } from "../pages/admin/companies/CompanyList";
import { CompanyDetail } from "../pages/admin/companies/CompanyDetail";
import { CompanyCreate } from "../pages/admin/companies/CompanyCreate";
import { CompanyEdit } from "../pages/admin/companies/CompanyEdit";
import { CompanyImport } from "../pages/admin/companies/CompanyImport";

export const companiesRoutes: RouteObject[] = [
  {
    id: "companies-list",
    index: true,
    element: <CompanyList />,
  },
  {
    id: "company-detail",
    path: ":id",
    element: <CompanyDetail />,
  },
  {
    id: "company-create",
    path: "create",
    element: <CompanyCreate />,
  },
  {
    id: "company-import",
    path: "import",
    element: <CompanyImport />,
  },
  {
    id: "company-edit",
    path: ":id/edit",
    element: <CompanyEdit />,
  },
];
